import { module } from 'modujs';
import { html } from '../utils/environment'

const CLASS = {
    OPEN: `has-menu-open`,
}

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                buttonClose: 'close'
            }
        }
    }

    init(){
        this.closeBind = (e) => {
             if (e.key === "Escape") {
                this.close();
            }
        }

        document.addEventListener('keyup', this.closeBind)
    }

    open() {
        html.classList.add(CLASS.OPEN)
        this.call('goToFirstSlide', null, 'MenuMobile');
    }

    close() {
        html.classList.remove(CLASS.OPEN)
    }

    destroy() {
        document.removeEventListener('keyup', this.closeBind)
    }
}
